import { StructCreate, StructEdit } from './StructCreateEdit'
import { StructList } from './StructList'

const structs = {
  list: StructList,
  create: StructCreate,
  edit: StructEdit,

  options: {
    basePath: '/structs/:structType',
    list: {
      title: 'Structured Configs',
    },
    create: {
      title: 'Create Structured Config',
    },
    edit: {
      title: 'Edit Structured Config',
    },
  },
}
export default structs
